import getOr from 'lodash/fp/getOr';
import { GLOBAL_CONSTANTS } from '../../global/constants';

import { exportRequirement, importRequirement, marketRank, potential, tradeStatistics } from "../../utils/api";
import { initTrackDetail, initTrackTradeAdrisory } from "../../utils/track";
import { nFormatter } from "../../utils/utils";
import { loadData, setUpMarketRank } from './marketRank';
import { showLimit } from "./searchBar";

const $ = window.jQuery;

export const initTradeAdvisory = () => {
  initTrackTradeAdrisory();
  setUpMarketRank();
  $('#detail .group').on('shown.bs.collapse', function (e) {
    if ($(e.target).hasClass("group") && window.outerWidth >= 992) {
      $(".section-requirement .container .row > div").addClass("deactive");
      $(".section-requirement .container .row > div").addClass("deactive");
      $(`.section-requirement .container .row > .${e.target.id}`).removeClass("deactive");
    }
  });

  $('#detail .group').on('hidden.bs.collapse', function (e) {
    if ($(e.target).hasClass("group") && window.outerWidth >= 992) {
      $(".section-requirement .container .row > div").removeClass("deactive");
    }
  });

  $(`[data-target="#domesticRegulations"]`).on("click", function (e) {
    if (window.outerWidth < 992 && !$(e.target).hasClass("need-help")) {
      e.stopPropagation();
      $(`[data-target="#domesticRegulations"]`).toggleClass("collapsed");
      $(`.domesticRegulations-mobile`).toggle();
    }
  })

  $(`[data-target="#productRegulations"]`).on("click", function (e) {
    if (window.outerWidth < 992 && !$(e.target).hasClass("need-help")) {
      e.stopPropagation();
      $(`[data-target="#productRegulations"]`).toggleClass("collapsed");
      $(`.productRegulations-mobile`).toggle();
    }
  })

  $(`[data-target="#marketRequirements"]`).on("click", function (e) {
    if (window.outerWidth < 992 && !$(e.target).hasClass("need-help")) {
      e.stopPropagation();
      $(`[data-target="#marketRequirements"]`).toggleClass("collapsed");
      $(`.marketRequirements-mobile`).toggle();
    }
  })

  $(`[data-target="#preshipmentCertifications"]`).on("click", function (e) {
    if (window.outerWidth < 992 && !$(e.target).hasClass("need-help")) {
      e.stopPropagation();
      $(`[data-target="#preshipmentCertifications"]`).toggleClass("collapsed");
      $(`.preshipmentCertifications-mobile`).toggle();
    }
  })
}

export const getStatictic = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  return tradeStatistics(params, function (data) {
    if (data.allPartnersValue || data.allPartnersValue === 0) {
      $(".section-import").css('display', 'block');
      $(".section-import .total-import").css('display', 'block');
      $(".section-import .total-import .value").text("USD " + nFormatter(data.allPartnersValue, 1));
      $(".section-import .total-import .value").attr("title", "USD " + data.allPartnersValue * 1, 1);
      $(".section-import .total-import .description").text("of global imports by " + destinationCountryObj.name + " for " + params.hs);
    }

    if (data.allPartnersWorldRank || data.allPartnersWorldRank === 0) {
      $(".section-import").css('display', 'block');
      $(".section-import .rank").css('display', 'block');
      $(".section-import .rank .value").text(data.allPartnersWorldRank);
      $(".section-import .rank .description").text(destinationCountryObj.name + "'s rank in global imports for " + params.hs);
    }

    if (data.bilateralShare || data.bilateralShare === 0) {
      $(".section-market").css('display', 'block');
      $(".section-market .share-import").css('display', 'block');
      $(".section-market .share-import .value").text(data.bilateralShare + "%");
      $(".section-market .share-import .description").text("of global import in " + destinationCountryObj.name + " for " + params.hs);
      $(".section-market .share-import img").hide();
      if (data.bilateralShare < 25) {
        $(".section-market .share-import img.share").css('display', 'block');
      }
      if (data.bilateralShare === 25) {
        $(".section-market .share-import img.share25").css('display', 'block');
      }
      if (data.bilateralShare > 25 && data.bilateralShare < 50) {
        $(".section-market .share-import img.share25").css('display', 'block');
      }
      if (data.bilateralShare === 50) {
        $(".section-market .share-import img.share50").css('display', 'block');
      }
      if (data.bilateralShare > 50 && data.bilateralShare < 75) {
        $(".section-market .share-import img.share60").css('display', 'block');
      }
      if (data.bilateralShare === 75) {
        $(".section-market .share-import img.share75").css('display', 'block');
      }
      if (data.bilateralShare > 75 && data.bilateralShare < 100) {
        $(".section-market .share-import img.share80").css('display', 'block');
      }
      if (data.bilateralShare === 100) {
        $(".section-market .share-import img.share100").css('display', 'block');
      }
    }

    if (data.bilateralGrowthRate || data.bilateralGrowthRate === 0) {
      $(".section-market").css('display', 'block');
      $(".section-market .growth").css('display', 'block');
      $(".section-market .growth .value").text(data.bilateralGrowthRate + "%");
      $(".section-market .growth .description").text(exportCountryObj.name + "'s import growth from " + destinationCountryObj.name + " for " + params.hs + " (from " + data.bilateralGrowthStartYear + " to " + data.bilateralGrowthEndYear + ")");
      $(".section-market .growth img").hide();
      if (data.bilateralGrowthRate > 0) {
        $(".section-market .growth img.up").css('display', 'block');
      } else {
        $(".section-market .growth img.down").css('display', 'block');
      }
    }

    if (!data.bilateralGrowthRate && data.bilateralGrowthRate !== 0 && (data.allPartnersGrowthRate || data.allPartnersGrowthRate === 0)) {
      $(".section-market").css('display', 'block');
      $(".section-market .growth").css('display', 'block');
      $(".section-market .growth .value").text(data.allPartnersGrowthRate + "%");
      $(".section-market .growth .description").text("From all suppliers for " + params.hs + " (from " + data.allPartnersGrowthStartYear + " to " + data.allPartnersGrowthEndYear + ")");
      $(".section-market .growth img").hide();
      if (data.allPartnersGrowthRate > 0) {
        $(".section-market .growth img.up").css('display', 'block');
      } else {
        $(".section-market .growth img.down").css('display', 'block');
      }
    }
    loadColor();
    $(".section-import, .section-market").removeClass('loading');
  }, function (error) {
    $(".section-import, .section-market").removeClass('loading');
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    console.error(error);
  }, apiTime);
}

export const getPotential = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  return potential(params, function (data) {
    if (data.totalExportPotential || data.totalExportPotential === 0) {
      $(".section-market").css('display', 'block');
      $(".section-market .potential").css('display', 'block');
      $(".section-market .potential .value").attr("title", "USD " + data.totalExportPotential * 1);
      $(".section-market .potential .value").text("USD " + nFormatter(data.totalExportPotential, 1));
      $(".section-market .potential img").hide();
      if (data.totalExportPotential > 0) {
        $(".section-market .potential img.up").css('display', 'block');
      } else {
        $(".section-market .potential img.down").css('display', 'block');
      }
      loadColor();
    }
    $(".section-market").removeClass('loading');
  }, function (error) {
    $(".section-market").removeClass('loading');
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    loadColor();
    console.error(error);
  }, apiTime);
}

export const getExportRequirement = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  return exportRequirement(params, function (data) {
    if (data.length) {
      $(".section-requirement").css('display', 'block');
      $(".section-requirement .domesticRegulations").css('display', 'flex');
      $(".section-requirement .domesticRegulations .value").text(data.length);
      let detail = "";
      data.forEach(element => {
        detail += element.genHtml();
      });
      $("#detail #domesticRegulations .table").html(detail);
      $(".domesticRegulations-mobile .table").html(detail);
      initTrackDetail();
    }
  }, function (error) {
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    console.error(error);
  }, apiTime);
}

export const getImportRequirement = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  // Don't know why below function block main thread
  return importRequirement(params, function (data) {
    if (data) {
      if (data.productRegulations.length) {
        $(".section-requirement").css('display', 'block');
        $(".section-requirement .productRegulations").css('display', 'flex');
        $(".section-requirement .productRegulations .value").text(data.productRegulations.length);
        let detail = "";
        data.productRegulations.forEach(element => {
          detail += element.genHtml();
        });
        $("#detail #productRegulations .table").html(detail);
        $(".productRegulations-mobile .table").html(detail);
      }
      if (data.marketRequirements.length) {
        $(".section-requirement").css('display', 'block');
        $(".section-requirement .marketRequirements").css('display', 'flex');
        $(".section-requirement .marketRequirements .value").text(data.marketRequirements.length);
        let detail = "";
        data.marketRequirements.forEach(element => {
          detail += element.genHtml();
        });
        $("#detail #marketRequirements .table").html(detail);
        $(".marketRequirements-mobile .table").html(detail);
      }
      if (data.preshipmentCertifications.length) {
        $(".section-requirement").css('display', 'block');
        $(".section-requirement .preshipmentCertifications").css('display', 'flex');
        $(".section-requirement .preshipmentCertifications .value").text(data.preshipmentCertifications.length);
        let detail = "";
        data.preshipmentCertifications.forEach(element => {
          detail += element.genHtml();
        });
        $("#detail #preshipmentCertifications .table").html(detail);
        $(".preshipmentCertifications-mobile .table").html(detail);
      }
      $(".section-requirement #col-import").removeClass('col-lg-3');
      $(".section-requirement #col-import").removeClass('col-lg-6');
      $(".section-requirement #col-import").removeClass('col-lg-9');
      $(".section-requirement #col-import").addClass("col-lg-" + (!!data.productRegulations.length + !!data.marketRequirements.length + !!data.preshipmentCertifications.length) * 3)
      initTrackDetail();
    }
  }, function (error) {
    $(".section-requirement").removeClass('loading');
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    console.error(error);
  }, apiTime);
}

export const getMarketRank = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  return marketRank({
    origin: exportCountryObj.iso2,
    product: params.hs,
    destinations: params.destinations
  }, function (data) {
    if (data.length) {
      loadData(data);
      loadColor();
    }
    $(".section-market-ranking").removeClass('loading');
  }, function (error) {
    $(".section-market-ranking").removeClass('loading');
    const errorCode = getOr('', 'error_code')(error);
    if (errorCode === GLOBAL_CONSTANTS.ERROR_CODE.LIMIT) {
      showLimit();
    }
    loadColor();
    console.error(error);
  }, apiTime);
}

export const loadColor = () => {
  if (window.page === 'tradeAdvisory') {
    $(".main-page > div.section:not('.section-header'):not('.section-footer'):not('.section-menu')").css('background', '');
    $(".main-page > div.section:not('.section-header'):not('.section-footer'):not('.section-menu'):visible:odd").css('background', '#FAFAFA');
  }
}